import * as React from "react";
const SvgInstantBook = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M13.727 2.432a.75.75 0 0 0-1.287-.68l-8 9A.75.75 0 0 0 5 12h2.668l-1.395 5.568a.75.75 0 0 0 1.288.68l8-9A.75.75 0 0 0 15 8h-2.668l1.395-5.568Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgInstantBook;
